import { createStore } from 'vuex'

import authModule from '../views/auth/store'

const store = createStore({
  modules: {
    authModule,
  }
})

export default store